export const settingsPath = (region: string) => `configuration/local/regions/${region}/settings`;
